export const haehnchenCrossis = {
	name: 'Gebackene Hähnchen Crossies aus dem Brustfilet',
	desc: 'Chili Dip, Weißkrautsalat und Pommes frites',
	image: 10,
	opinions: [
		{
			name: 'Marianne Mielke',
			date: '7. Dezember 2017',
			title: 'Crossies geht so',
			content: 'Bei mir war da nichts kross. Und wenn schon sündigen, dann muss es leckerer sein :)',
			rating: 2,
		},
	],
	recommandation: 'Ein Joghurt als Nachtisch liefert noch etwas Calcium und hilft dem Magen bei der Verdauung.',
	warnings: ['huhn', 'weizen', 'gluten', 'zucker', 'fleischAllgemein'],
	ingredients: [
		{'Hähnchenbrustfilet': 'huhn'},
		'Mais',
		{'Zucker': 'zucker'},
		{'Gerstenmalz': 'zucker'},
		'Salz',
		{'Glucosesirup': 'zucker'},
		{'Mehl': 'weizen, gluten'},
		'Salz',
		'Pfeffer',
		'Paprikapulver',
		'Weißkohl',
		'Kräuteressig',
		'Sonnenblumenöl',
	],
};



// WEBPACK FOOTER //
// ./src/dishes/single-dishes/haehnchenCrossis.js